import { useEffect, useState } from "react";
import { ComponentProps } from "@arelia-types/widget";
import PlanBreakdownPresenter from "./PlanBreakdownPresenter";
import { useHqCustomersAPI } from "src/features/hq/customers/hq-customers.api";
import { SubscriptionPlanName } from "@arelia-types/subscriptions";

type PlanBreakdownData = {
  MySocial: { paid: number; free: number };
  MySocialMyFans: { paid: number; free: number };
  Starter: number;
};

export default function PlanBreakdownContainer({ config }: ComponentProps) {
  const [planBreakdown, setPlanBreakdown] = useState<PlanBreakdownData>({
    MySocial: { paid: 0, free: 0 },
    MySocialMyFans: { paid: 0, free: 0 },
    Starter: 0,
  });

  const { data: customers, isFetching } = useHqCustomersAPI();

  useEffect(() => {
    if (!customers) return;

    const next: PlanBreakdownData = {
      MySocial: { paid: 0, free: 0 },
      MySocialMyFans: { paid: 0, free: 0 },
      Starter: 0,
    };

    for (const c of customers) {
      const sub = c?.subscription;
      if (!sub?.plan) continue;

      const isFree = Boolean(sub.isFreePlan);

      switch (sub.plan as SubscriptionPlanName) {
        case SubscriptionPlanName.MySocial:
          next.MySocial[isFree ? "free" : "paid"] += 1;
          break;

        case SubscriptionPlanName.MySocialMyFans:
          next.MySocialMyFans[isFree ? "free" : "paid"] += 1;
          break;

        case SubscriptionPlanName.Starter:
          next.Starter += 1;
          break;

        case SubscriptionPlanName.Free:
          break;

        default:
          break;
      }
    }

    setPlanBreakdown(next);
  }, [customers]);

  return (
    <PlanBreakdownPresenter
      data={planBreakdown}
      loading={isFetching}
      widgetConfig={config}
    />
  );
}
